import React from 'react';
import { FormikField, TextInput } from '@feast-it/pesto';

const SupplierManual = () => (
  <>
    <FormikField
      as={TextInput}
      label="Address line 1"
      name="supplier.location_line_1"
      mb={4}
      color="blueDark"
      fontFamily="body"
    />
    <FormikField
      as={TextInput}
      label="Address line 2"
      name="supplier.location_line_2"
      mb={4}
      color="blueDark"
      fontFamily="body"
    />
    <FormikField
      as={TextInput}
      label="City"
      name="supplier.location_city"
      mb={4}
      color="blueDark"
      fontFamily="body"
    />
    <FormikField
      as={TextInput}
      label="Postcode"
      name="supplier.postcode"
      mb={4}
      color="blueDark"
      fontFamily="body"
    />
  </>
);

export default SupplierManual;
